export const typeFetchBlacklist = new Set([
    'ShareFileFolder',
    'Parameter',
    'TInputs',
    'DocumentTemplate',
    'MergeField',
    'Url',
]);
export var ExpressionMemberType;
(function (ExpressionMemberType) {
    ExpressionMemberType["literal"] = "literal";
    ExpressionMemberType["symbol"] = "symbol";
    ExpressionMemberType["expression"] = "expression";
    ExpressionMemberType["operator"] = "operator";
    ExpressionMemberType["call"] = "call";
    ExpressionMemberType["entity"] = "entity";
})(ExpressionMemberType || (ExpressionMemberType = {}));
export var PrimitiveTypes;
(function (PrimitiveTypes) {
    PrimitiveTypes["string"] = "string";
    PrimitiveTypes["number"] = "number";
    PrimitiveTypes["boolean"] = "boolean";
    PrimitiveTypes["Url"] = "Url";
})(PrimitiveTypes || (PrimitiveTypes = {}));
export var HandleType;
(function (HandleType) {
    HandleType["Action"] = "Action";
    HandleType["ActionArgument"] = "ActionArgument";
    HandleType["BlueprintArgument"] = "BlueprintArgument";
    HandleType["Parameter"] = "Parameter";
    HandleType["TriggerArgument"] = "TriggerArgument";
    HandleType["TriggerGenericTypeArgument"] = "TriggerGenericTypeArgument";
    HandleType["TriggerContextArgument"] = "TriggerContextArgument";
    HandleType["Default"] = "Default";
    HandleType["ArrayItem"] = "ArrayItem";
})(HandleType || (HandleType = {}));
export var DefinitionValidity;
(function (DefinitionValidity) {
    DefinitionValidity["VALID"] = "VALID";
    DefinitionValidity["EMPTY"] = "EMPTY";
    DefinitionValidity["INVALID"] = "INVALID";
    DefinitionValidity["FATAL"] = "FATAL";
})(DefinitionValidity || (DefinitionValidity = {}));
//# sourceMappingURL=types.js.map